module.exports = __webpack_public_path__ + "static/receiver-2-homepage-video-80eabee93c86aab54311a468b9cee393.mp4";